var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5498 20.325C23.5498 18.9127 24.1108 17.5583 25.1095 16.5597C26.1081 15.561 27.4625 15 28.8748 15C30.2871 15 31.6415 15.561 32.6401 16.5597C33.6388 17.5583 34.1998 18.9127 34.1998 20.325V29.2C34.1998 30.6123 33.6388 31.9667 32.6401 32.9653C31.6415 33.964 30.2871 34.525 28.8748 34.525C27.4625 34.525 26.1081 33.964 25.1095 32.9653C24.1108 31.9667 23.5498 30.6123 23.5498 29.2V20.325Z",
    fill: "#14AE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8875 26.5375C21.1229 26.5375 21.3486 26.631 21.5151 26.7974C21.6815 26.9639 21.775 27.1896 21.775 27.425V29.2C21.775 31.083 22.523 32.8889 23.8545 34.2204C25.186 35.5519 26.992 36.3 28.875 36.3C30.758 36.3 32.5639 35.5519 33.8955 34.2204C35.227 32.8889 35.975 31.083 35.975 29.2V27.425C35.975 27.1896 36.0685 26.9639 36.2349 26.7974C36.4014 26.631 36.6271 26.5375 36.8625 26.5375C37.0979 26.5375 37.3236 26.631 37.4901 26.7974C37.6565 26.9639 37.75 27.1896 37.75 27.425V29.2C37.75 31.4001 36.9328 33.5219 35.4569 35.1536C33.981 36.7853 31.9516 37.8106 29.7625 38.0306V41.625H35.0875C35.3229 41.625 35.5486 41.7185 35.7151 41.8849C35.8815 42.0514 35.975 42.2771 35.975 42.5125C35.975 42.7479 35.8815 42.9736 35.7151 43.14C35.5486 43.3065 35.3229 43.4 35.0875 43.4H22.6625C22.4271 43.4 22.2014 43.3065 22.0349 43.14C21.8685 42.9736 21.775 42.7479 21.775 42.5125C21.775 42.2771 21.8685 42.0514 22.0349 41.8849C22.2014 41.7185 22.4271 41.625 22.6625 41.625H27.9875V38.0306C25.7984 37.8106 23.769 36.7853 22.2931 35.1536C20.8172 33.5219 20 31.4001 20 29.2V27.425C20 27.1896 20.0935 26.9639 20.2599 26.7974C20.4264 26.631 20.6521 26.5375 20.8875 26.5375Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.3067effca5ad333532e90357d1cb71ff.svg";
export { ForwardRef as ReactComponent };